export const VARIANTS = {
  CONTAINER_VARIANT: {
    open: {
      y: 0,
      opacity: 1
    },
    closed: {
      y: -10,
      opacity: 0
    }
  },
  SECTION_VARIANT: {
    open: {
      transition: { staggerChildren: 0.07, delayChildren: 0.2 }
    },
    closed: {
      transition: { staggerChildren: 0.05, staggerDirection: -1 }
    }
  },
  ITEM_VARIANT: {
    open: {
      y: 0,
      opacity: 1,
      transition: {
        y: { stiffness: 1000, velocity: -100 }
      }
    },
    closed: {
      y: 50,
      opacity: 0,
      transition: {
        y: { stiffness: 1000 }
      }
    }
  }
};
